<template>
<div>
  <vue-headful :title="site_title" />
  <Header />
  <!-- pages widget -->
  <template v-if="response">
    <template v-if="response.ok">
      <table class="pms__wrappertable" width="100%">
        <tr>
          <!--left side -->
          <td width="24%" valign="top">
            <UserControlPanel :inbox="response['inbox']" :outbox="response['outbox']" :unsent="response['unsent']" />
          </td>

          <!-- empty separator -->
          <td width="1%"></td>

          <!--right side -->
          <template v-if="response.pm">
            <td width="75%" valign="top">
              <div class="ucp__content">
                <div class="ucp__maintitle">Добро пожаловать в ваши личные данные </div>

                <!--{{this.response}}-->
                <div class="pm__content_wrap">
                  <div class="ucp__formsubtitle pm__subtitle">
                    {{htmlDecode(response.pm.posttitle)}}
                    <div class="forum__forward_message" style="float: right;">
                      <a>Переадресовать сообщение</a> | <a>Ответить</a>
                    </div>
                  </div>
                  <table class="pm__table" width="100%">
                    <!-- top line -->
                    <tr class="forum__thread_row_top">
                      <td class="pm__firstColumn thread__nickname pm__nickname" align="center"><b><a :href="'index.php?showuser='+response.pm.posterid">{{htmlDecode(response.pm.postername)}}</a></b></td>
                      <td class="pm__box_above_post">
                        <div style="display: flex; align-items: center;" class="thread__post_date_flex">
                          <div style="width: 60%;">
                            <b>Отправлено:</b> {{response.pm.postdate | formatDate}}
                          </div>
                          <div style="width: 40%; text-align: right;">
                            <a><img src="../assets/p_quote.gif"></a>
                          </div>
                        </div>
                      </td>
                    </tr>

                    <!-- mid line -->
                    <tr class="forum__thread_row_mid">

                      <!-- Avatar and other info -->
                      <td class="post_left_side" valign="top" align="center">
                        <template v-if="response.pm.avatar != null && response.pm.avatar.length > 0 && response.pm.avatar.avatar !== 'noavatar'">
                          <img class="avatar" :src="fixAvatarPath(response.pm.avatar)" />
                        </template>
                        <br>
                        <!-- title -->
                        {{htmlDecode(response.pm.title)}}
                        <br>
                        <!-- PIPS -->
                        <div class="poster__pips">
                          <template v-if="response.pm.posterid == 10 || response.pm.posterid == 30">
                            <img src="../assets/vave_pips.gif" />
                          </template>
                          <template v-else-if="response.pm.posterid == 687">
                            <img style="padding-top: 2px;" src="../assets/exdeath_pips.gif" />
                          </template>
                          <template v-else v-for="n in response.pm.pips">
                            <img src="../assets/star.gif" alt="*">
                            <template v-if="n < response.pm.pips"><span v-html="nbsp"></span></template>
                          </template>
                        </div>

                        <div class="poster_info" v-bind:class="{vave_info: response.pm.posterid == 10 || response.pm.posterid == 30}">
                          <!-- joined -->
                          <template v-if="response.pm.posterid > -1">
                            <div v-bind:class="{vave_joined: response.pm.posterid == 10 || response.pm.posterid == 30}">
                              <template v-if="response.pm.posterid == 10">Вступил: 7 Января, 0 года<br></template>
                              <template v-else>
                                Вступил<template v-if="response.pm.gender == 'f'">а</template>: {{response.pm.joined | formatDateShort}}<br>
                              </template>
                            </div>
                          </template>
                          <!-- Posts -->
                          <font color="#00cc00">
                            <template v-if="response.pm.posterid == 10">
                              Опыт: Лимит<br>
                            </template>
                            <template v-else-if="response.pm.posterid > -1">
                              Опыт: {{response.pm.posterposts}} XP<br>
                            </template>
                          </font>
                          <!-- Gold -->
                          <template v-if="response.pm.posterid > -1">
                            <font color="#ffcc33">Золото: {{response.pm.posterid === 10 ? '&infin;' : response.pm.gold}}</font><br> <!-- VaVe special case: infinite gold -->
                          </template>
                        </div>
                        <div style="width: 165px; height: 1px;"></div>
                      </td>

                      <!-- THE POST -->
                      <td class="post_right_side" width="100%" valign="top">
                        <div v-html="fixQuoteTags(fixVariousTags(fixRpgplanetLinks(fixRealmsMainPaths(fixSmileysPath(response.pm.post))), post))"></div>

                        <!-- Signature -->
                        <div class="thread__signature" v-if="response.pm.signature && response.pm.signature.length > 0">
                          <br><br>
                          --------------------
                          <br>
                          <div v-html="fixVariousTags(fixRpgplanetLinks(response.pm.signature))"></div>
                        </div>
                      </td>
                    </tr>

                    <!-- bottom line -->
                    <tr class="forum__thread_row_bottom pm__bottom_line">
                      <td class="pm__firstColumn" style="font-size:11px;">

                      </td>
                      <td>
                        <div style="display: flex; align-items: center; line-height: 80%;">
                          <a :href="'index.php?showuser='+response.pm.posterid"><img src="../assets/p_card.gif"></a> <span v-html="nbsp"></span><a><img src="../assets/p_pm.gif"></a> <span v-html="nbsp"></span><a><img src="../assets/p_email.gif"></a>
                        </div>
                      </td>
                    </tr>
                  </table>
                </div>

              </div>
            </td>
          </template>
          <template v-else>
            У вас нет доступа к этому сообщению.
          </template>
        </tr>
      </table>
      <FooterPermanent v-if="footerReady" :loadTime="loadTime" :totalRequests="response.queries" />
    </template>
    <template v-else>
      Пожалуйста перелогиньтесь.
    </template>
  </template>
</div>
</template>

<script>
import Header from './Header'
import UserControlPanel from './UserControlPanel'
import FooterPermanent from './FooterPermanent'
import {
  globalFormatDate
} from '../../public/utils.js';

export default {
  components: {
    Header,
    FooterPermanent,
    UserControlPanel,
  },
  data: function() {
    return {
      response: null,
      footerReady: false
    }
  },
  async created() {
    let dateEarly = new Date();
    let response = null;
    if (this.$route.query.MSID) {
      response = await fetch(this.getNodePath() + 'pms/get/' + this.$route.query.MSID);
      let dateLater = new Date();
      this.response = await response.json();
      this.loadTime = this.spanSeconds(dateEarly, dateLater);
      this.footerReady = true;
    }
  },
  methods: {
    fixSmileysPath(postText) {
      return postText.replace(/<#EMO_DIR#>\//g, "");
    },
    fixRpgplanetLinks(html) {
      // oldforums.rpgplanet.ru to /oldforums/, examples: http://localhost:8080/index.php?showtopic=221#2995
      // steelworld.rpgplanet.ru/forums/ to local url
      // etc,.. many such cases.
      // eg. http://localhost:8080/index.php?showtopic=3603 , http://localhost:8080/index.php?showtopic=192&st=268
      return html.replace(/<a href=("|')http:\/\/((www|forums)\.){0,2}((.{0,15}?)\.){0,1}?(rpgplanet|realms)\.ru(\/forums)?/gu, function(a, b, c, d, e, f) {
          let result = '';
          if (f) {
            result = `<a href=${b}/${f}`;
          } else {
            result = `<a href=${b}`;
          }
          return result;
        })
        // img src="http://www.rpgplanet.ru/forums" (and without forums) to local website url
        .replace(/<img src="http:\/\/www\.rpgplanet\.ru(\/forums){0,1}/g, function(a, b) {
          return a.replace("http://www.rpgplanet.ru/forums", "").replace("http://www.rpgplanet.ru", "");
        });
    },
    fixVariousTags(html) {
      // [mergetime=1232312] turns it into Добавлено: дата
      return html.replace(/\[mergetime=(\d+)\]/g, function(a, b) {
          return '<b>Добавлено: ' + globalFormatDate(b) + '</b>';
        })
        // changes [hide]text[/hide] to <i>text</i> - hide tag was used to hide info from unregistered users only
        .replace(/\[hide\](.*?)\[\/hide\]/gi, "<i>$1</i>")
        // change [topic=123]text[/topic] to <a href="index.php?showtopic=123">text</a>
        .replace(/\[topic=([0-9]+)\](.+?)\[\/topic\]/gi, "<a href=\"/index.php?showtopic=$1\">$2</a>")
        // same with [user]
        .replace(/\[user=([0-9]+)\](.+?)\[\/user\]/gi, "<a href=\"/index.php?showuser=$1\">$2</a>")
        // same with [forum]
        .replace(/\[forum=([0-9]+)\](.+?)\[\/forum\]/gi, "<a href=\"/index.php?showforum=$1\">$2</a>")
        // same with [post]
        .replace(/\[post=([0-9]+)\](.+?)\[\/post\]/gi, "<a href=\"/index.php?view=findpost&p=$1\">$2</a>")
        // [hl] tag gives text a different color
        .replace(/\[hl\](.+?)\[\/hl\]/gi, "<span class=\"thread__hl\">$1</span>");
    },
    fixQuoteTags(html) {
      return html.replace(/\[QUOTE\]((.|\n)*)\[\/QUOTE\]/gui, function(a, b) {
          let result = '<div class="quotetop">Цитата</div>';
          result += '<div class="quotemain">'
          result += b;
          result += '</div>';
          return result;
        })
        .replace(/\[QUOTE\]((.|\n)*)\[\/QUOTE\]/gui, function(a, b) {
          let result = '<div class="quotetop">Цитата</div>';
          result += '<div class="quotemain">'
          result += b;
          result += '</div>';
          return result;
        })
        .replace(/\[QUOTE\]((.|\n)*)\[\/QUOTE\]/gui, function(a, b) {
          let result = '<div class="quotetop">Цитата</div>';
          result += '<div class="quotemain">'
          result += b;
          result += '</div>';
          return result;
        })
        .replace(/\[QUOTE\]((.|\n)*)\[\/QUOTE\]/gui, function(a, b) {
          let result = '<div class="quotetop">Цитата</div>';
          result += '<div class="quotemain">'
          result += b;
          result += '</div>';
          return result;
        })
        .replace(/\[QUOTE\]((.|\n)*)\[\/QUOTE\]/gui, function(a, b) {
          let result = '<div class="quotetop">Цитата</div>';
          result += '<div class="quotemain">'
          result += b;
          result += '</div>';
          return result;
        });
    },
  },
  filters: {
    consumeN: function(number) {
      return "*";
    }
  }
}
</script>

<style lang="scss">
@import "./PMs.scss";
@import "../skin-blue.scss";
@import "./Thread.scss";

.forum__forward_message {
    color: #fff;
    a {
        color: #50bba8;
    }
}

.pm__table {
    td,
    th,
    tr {
        border: 1px solid #303088;
    }
}

.pm__subtitle {
    height: 13px;
    padding: 8px;
}

.pm__nickname {
    a {
        color: #ffff00;
        text-decoration: none;
        &:hover {
            color: #fff;
        }
    }
}

.pm__bottom_line {
    td {
        padding: 4px;
    }
}
</style>
